import React from 'react';
import {
  Box,
  Typography,
  Grid,
} from '@mui/material';
import {
  QuickStatsWidget,
  TodayTasksWidget,
  OverdueTasksWidget,
  RecentLeadsWidget,
  UpcomingBookingsWidget,
  PendingInvoicesWidget,
  ContractStatusWidget,
} from '../components/dashboard/widgets';
import AnalyticsDashboardWidget from '../components/analytics/AnalyticsDashboardWidget';
import { useAuth } from '../contexts/AuthContext';

export const Dashboard: React.FC = () => {
  const { user, organization } = useAuth();

  const firstName = user?.profile?.firstName || 'there';

  // Analytics widget is only available for Rise+ tiers
  const canViewAnalytics =
    organization?.subscription?.tier &&
    ['rise', 'summit'].includes(organization.subscription.tier);

  // Contracts widget is available for Rise+ tiers
  const canViewContracts =
    organization?.subscription?.tier &&
    ['rise', 'summit'].includes(organization.subscription.tier);

  return (
    <Box>
      {/* Header */}
      <Box mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Welcome back, {firstName}!
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Here's what's happening with your business today.
        </Typography>
      </Box>

      {/* Analytics Widget - Rise+ only */}
      {canViewAnalytics && (
        <Box sx={{ mb: 3 }}>
          <AnalyticsDashboardWidget />
        </Box>
      )}

      {/* Widgets Grid */}
      <Grid container spacing={3}>
        {/* Quick Stats - Full Width */}
        <Grid item xs={12}>
          <QuickStatsWidget />
        </Grid>

        {/* Today's Tasks */}
        <Grid item xs={12} md={6} lg={4}>
          <TodayTasksWidget />
        </Grid>

        {/* Overdue Tasks */}
        <Grid item xs={12} md={6} lg={4}>
          <OverdueTasksWidget />
        </Grid>

        {/* Recent Leads */}
        <Grid item xs={12} md={6} lg={4}>
          <RecentLeadsWidget />
        </Grid>

        {/* Upcoming Bookings */}
        <Grid item xs={12} md={6} lg={4}>
          <UpcomingBookingsWidget />
        </Grid>

        {/* Pending Invoices */}
        <Grid item xs={12} md={6} lg={4}>
          <PendingInvoicesWidget />
        </Grid>

        {/* Contracts Widget - Rise+ only */}
        {canViewContracts && (
          <Grid item xs={12} md={6} lg={4}>
            <ContractStatusWidget />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default Dashboard;
